import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BisacCodesBrowser } from "components/BisacCodes/BisacCodesBrowser";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";

interface BrowseBisacCodesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function BrowseBisacCodesDialog({
  open,
  onOpenChange,
}: BrowseBisacCodesDialogProps) {
  const { t } = useTranslation(["books"]);
  const [submittedQuery, setSubmittedQuery] = useState("");

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) setSubmittedQuery("");
    onOpenChange(nextOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        className="min-w-[90vw] max-w-[90vw] h-[85vh] flex flex-col"
        data-testid="browse-bisac-codes-dialog"
      >
        <DialogHeader className="items-start">
          <DialogTitle>{t("books:filters.bisacCodes.browseTitle")}</DialogTitle>
          <DialogDescription>
            {t("books:filters.bisacCodes.browseDescription")}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col flex-1 min-h-0">
          <BisacCodesBrowser
            submittedQuery={submittedQuery}
            onSubmittedQueryChange={setSubmittedQuery}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
